// src/components/Views/Gear/TransferSimpleModal.js
import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "../../../css/Views/TransferSimpleModal.css";

const TransferSimpleModal = ({ isOpen, gearLabel, maxCount, recipients, onClose, onSubmit }) => {
  const [recipientId, setRecipientId] = useState("");
  const [count, setCount] = useState("1");
  const [note, setNote] = useState("");

  if (!isOpen) return null;

  const handleSubmit = () => {
     const numericCount = Number(count || 0);
  if (!recipientId || numericCount <= 0 || numericCount > maxCount) return;
  onSubmit({ recipientId: Number(recipientId), count: numericCount, note });
  };

  const onBackdrop = (e) => {
    if (e.target.classList.contains("tm-backdrop")) onClose();
  };

  return (
    <div className="tm-backdrop" onMouseDown={onBackdrop}>
      <div className="tm-card" role="dialog" aria-modal="true" aria-labelledby="tm-title">
        <div className="tm-header">
          <div id="tm-title" className="tm-title">Przekaż: {gearLabel}</div>
          <button className="tm-icon-btn" onClick={onClose} aria-label="Zamknij">
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <div className="tm-body">
          <div className="tm-row">
            <label>Odbiorca</label>
            <select value={recipientId} onChange={(e) => setRecipientId(e.target.value)}>
              <option value="">— wybierz osobę —</option>
              {recipients.map((r) => (
                <option key={r.userId} value={r.userId}>
                  {r.preferredName ?? `Użytkownik #${r.userId}`}
                </option>
              ))}
            </select>
          </div>

          <div className="tm-row">
            <label>Liczba (max {maxCount})</label>
            <input
              type="number"
              value={count}
              min={1}
              max={maxCount}
              onChange={(e) => setCount(e.target.value)}
            />
          </div>

          <div className="tm-row">
            <label>Notatka</label>
            <textarea rows={3} value={note} onChange={(e) => setNote(e.target.value)} />
          </div>
        </div>

        <div className="tm-actions">
          <button className="tm-btn" onClick={onClose}>Anuluj</button>
          <button className="tm-btn tm-primary" onClick={handleSubmit}>Przekaż</button>
        </div>
      </div>
    </div>
  );
};

export default TransferSimpleModal;